export enum MessageRef {
    Task = 1,
    Location = 2
}